import { render, staticRenderFns } from "./goodslistdetails.vue?vue&type=template&id=79ec62b4&scoped=true&"
import script from "./goodslistdetails.vue?vue&type=script&lang=js&"
export * from "./goodslistdetails.vue?vue&type=script&lang=js&"
import style0 from "./goodslistdetails.vue?vue&type=style&index=0&id=79ec62b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec62b4",
  null
  
)

export default component.exports